var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-download-qr",attrs:{"aria-label":"扫码下载久朋APP"}},[_c('img',{staticClass:"qr-img",attrs:{"src":_vm.qrImg,"alt":"久朋APP二维码"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-text"},[_c('div',{staticClass:"qr-title"},[_vm._v("扫码下载久朋APP")]),_c('div',{staticClass:"qr-version"},[_vm._v("V1.2.0")])])
}]

export { render, staticRenderFns }